import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import ButtonOptionSystem from '../../../../components/NovoSistema/ButtonOptionSystem';
import { SelectSystemHeader } from '../../../../components/NovoSistema/SelectSystemHeader';
import ContasAPagar from './ContasAPagar';
import ContasAReceber from './ContasAReceber';
import CotacaoDeCompra from './CotacaoDeCompra';
import FluxoDeCaixa from './FluxoDeCaixa';
import PedidoDeCompra from './PedidoDeCompra';
import ConciliacaoBancaria from './ConciliacaoBancaria';
import AprovacaoPO from './AprovacaoPO';
import Boletos from './Boletos';
import CadastroDeUsuario from '../../CadastroDeUsuario';
import Estoque from './Estoque';

export default function TemplateGestaoFinanceira() {
  const [systemOption, setSystemOption] = useState('');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Gestão Financeira" linkIcon="/images/icons/court.svg" />
        <SelectSystemHeader>
          <ButtonOptionSystem
            systemName="Contas a Receber"
            border="#70309F"
            active={systemOption === 'Contas a Receber' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Contas a Pagar"
            border="#70309F"
            active={systemOption === 'Contas a Pagar' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cotação de Compra"
            border="#70309F"
            active={systemOption === 'Cotação de Compra' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Pedido de Compra"
            border="#70309F"
            active={systemOption === 'Pedido de Compra' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Aprovação PO"
            border="#70309F"
            active={systemOption === 'Aprovação PO' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Estoque"
            border="#70309F"
            active={systemOption === 'Estoque' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Fluxo de Caixa"
            border="#70309F"
            active={systemOption === 'Fluxo de Caixa' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Conciliação Bancária"
            border="#70309F"
            active={systemOption === 'Conciliação Bancária' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Boletos"
            border="#70309F"
            active={systemOption === 'Boletos' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Cadastro de Usuário"
            border="#70309F"
            active={systemOption === 'Cadastro de Usuário' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
        </SelectSystemHeader>
        {systemOption === 'Contas a Receber' && <ContasAReceber />}
        {systemOption === 'Contas a Pagar' && <ContasAPagar />}
        {systemOption === 'Cotação de Compra' && <CotacaoDeCompra />}
        {systemOption === 'Pedido de Compra' && <PedidoDeCompra />}
        {systemOption === 'Aprovação PO' && <AprovacaoPO />}
        {systemOption === 'Estoque' && <Estoque />}
        {systemOption === 'Fluxo de Caixa' && <FluxoDeCaixa />}
        {systemOption === 'Conciliação Bancária' && <ConciliacaoBancaria />}
        {systemOption === 'Boletos' && <Boletos />}
        {systemOption === 'Cadastro de Usuário' && <CadastroDeUsuario />}
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
